module.exports = __webpack_public_path__ + "img/home__1fkc——zh.a3a0e2dc.png";